/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import HomepageCard from '../partials/HomepageCard';

export const NetworkSection = () => {

  const externalOnClick = (link: string) => () => window.open(link);

  return <>
    <h3 className='mt-4'>Wider network</h3>
    <div className='mt-2 d-flex flex-wrap justify-content-around justify-content-md-between'>
      <HomepageCard button={{ text: 'see more' }} buttonColour='secondary' btnOutline={false}
                    buttonOnClick={externalOnClick('https://www.g17.eco/solutions')} className='mb-3 background-BrandBlue'>
        <h3>Sustainability<br />Solutions</h3>
      </HomepageCard>
      <HomepageCard button={{ text: 'see more' }} buttonColour='secondary' btnOutline={false}
                    buttonOnClick={externalOnClick('https://www.g17.eco/institute')} className='mb-3 background-BrandGreen'>
        <h3>Sustainability<br />Education</h3>
      </HomepageCard>
      <HomepageCard button={{ text: 'coming soon', disabled: true }} buttonColour='secondary' btnOutline={false}
                    buttonOnClick={externalOnClick('https://www.g17.eco')} className='mb-3 background-BrandRed'>
        <h3>Sustainability<br />Finance</h3>
      </HomepageCard>
    </div>
  </>;
};
